import React from 'react'
import {connect} from 'react-redux'
import { 
  Glyphicon, OverlayTrigger, Tooltip,
  ListGroupItem
} from 'react-bootstrap'
import { Link } from 'react-router'
import moment from 'moment'
import { getText } from '../lib/text.js'

/**
 * 
 */

const FauxCheckbox = ({ onChange, text, checked, glyph, color, lightColor }) => (
  <OverlayTrigger 
    placement="top"
    overlay={ 
      <Tooltip 
        style={{ fontSize: 15 }}
        id={text}
      >
        {text}
      </Tooltip> 
    }
  >
    <div
      onClick={() => onChange(!checked)}
      style={{ 
        display: "inline-block", 
        height: 30, 
        width: 24, 
        paddingLeft: 2, 
        color, 
        borderWidth: 2, 
        borderStyle: "solid",
        borderColor: checked ? color : lightColor, 
        backgroundColor: checked ? lightColor : `white`, 
        marginRight: 4,
        cursor: "pointer"
      }}
    >
      <Glyphicon
        glyph={glyph}
        style={{opacity: checked ? 1 : 0.5}}
      />
    </div>
  </OverlayTrigger>
)

/**
 * 
 */

function getWeekday(m: string): string {
  return getText([
    "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
  ][moment(m).day()])
}

/**
 * 
 */

type TaskProps = {
  active: boolean, 
  disabled: boolean,
  includeTrip: boolean, 
  onChange: Object => void, 
  onEdit: () => void, 
  task: Object, 
  Trips: Object,
}

const Task = ({ active, disabled, onChange, onEdit, task, includeTrip, Trips }: TaskProps) => (
  <ListGroupItem
    disabled={disabled}
    style={{ backgroundColor: active ? "rgb(220, 220, 255)" : "white", padding: 0 }}
  >
    <div style={{ position: "absolute", top: 5, left: 5, display:"inline", padding: 0 }}>
      <FauxCheckbox 
        text={getText("Hecho")}
        glyph="ok"
        color="rgba(50, 190, 0, 1)"
        lightColor="rgba(50, 190, 0, 0.5)"
        checked={task.status === "done"}
        onChange={v => (v ? onChange({ status: "done" }) : onChange({ status: "pending" }))}
      />
      <FauxCheckbox 
        text={getText("No hace falta")}
        glyph="remove"
        color="rgba(255, 128, 0, 1)"
        lightColor="rgba(255, 128, 0, 0.5)"
        checked={task.status === "passed"}
        onChange={v => (v ? onChange({ status: "passed" }) : onChange({ status: "pending" }))}
      />
      <FauxCheckbox 
        text={getText("Fallido")}
        glyph="remove"
        color="rgba(255, 0, 0, 1)"
        lightColor="rgba(255, 0, 0, 0.5)"
        checked={task.status === "failed"}
        onChange={v => (v ? onChange({ status: "failed" }) : onChange({ status: "pending" }))}
      />
    </div>
    
    <div style={{ marginLeft: 90, marginRight: 45 }}>
      <div>
        <span style={{ fontWeight: active ? "bold" : "normal" }}>
          {
            task.trip && includeTrip
            ? (
              <span>
                <Link to={`/private/trip/${task.trip}`}>
                  {Trips[task.trip].realName || Trips[task.trip].name || getText("Cliente sin nombre")}
                </Link>
                {": "}
              </span>) 
            : ""
          }
          {task.text || " - "}
        </span>
      </div>
      
      <div>
        <em>{" "}({task.dueDate ? `${getWeekday(task.dueDate)} ${task.dueDate}` : getText("sin fecha")}, {task.user}{task.plan ? `, ${task.plan}` : ""})</em>
      </div>
    </div>

    <div style = {{ position: "absolute", right: 5, top: 5 }}>
      <a href="#" onClick={() => onEdit()}>{getText("Editar")}</a>
    </div>

  </ListGroupItem>
)

const stateToProps = (state, props) => ({
  Trips: state.trips
})

const dispatchToProps = (dispatch) => ({})

export default connect(stateToProps, dispatchToProps)(Task)
